import { Card, CardContent, Paper, Tab, Tabs } from '@material-ui/core';
import { FormikHandlers, FormikHelpers } from 'formik';
import React, { useEffect, useState } from 'react';
import Wysiwyg from '../../../../common/components/fields/wysiwyg';
import TabPanel from '../../../../common/components/tabPanel';
import { LanguagesEnum_class } from '../../../../common/enums/languages';
import { ExhibitContentDto, exhibitContentInit } from '../../exhibits.dtos';

interface IProps {
  content: ExhibitContentDto[];
  onChange: FormikHelpers<ExhibitContentDto>['setFieldValue'];
}

const ExhibitContent: React.FC<IProps> = ({ content, onChange }) => {
  const [tab, setTab] = useState(1);
  const [exhibitContent, setExhibitContent] = useState<ExhibitContentDto>(
    exhibitContentInit
  );

  useEffect(() => {
    const index = content.findIndex((c) => c.languageId === tab);
    setExhibitContent(content[index]);
  }, [content]);

  const handleChange = (event: React.ChangeEvent<{}>, newTab: number) => {
    setTab(newTab);
    setContentOnChange(newTab);
  };

  const handleContentChange = (newContent: ExhibitContentDto) => {
    const index = content.findIndex(
      (c) => c.languageId === newContent.languageId
    );
    const copy = [...content];
    copy[index] = newContent;
    onChange('content', copy);
  };

  const setContentOnChange = (newTab: number) => {
    const index = content.findIndex((c) => c.languageId === newTab);
    setExhibitContent(content[index]);
  };

  return (
    <Card>
      <CardContent>
        <Paper square>
          <Tabs
            indicatorColor='primary'
            textColor='primary'
            value={tab}
            onChange={handleChange}
          >
            {Object.keys(LanguagesEnum_class.enumByNumber)
              .filter((f) => isNaN(+f) === false)
              .map((o, i) => (
                <Tab
                  key={o.toString() + i}
                  label={LanguagesEnum_class.enumByNumber[+o]}
                  value={+o}
                />
              ))}
          </Tabs>
        </Paper>
        <TabPanel index={tab} value={tab}>
          <Wysiwyg content={exhibitContent} onChange={handleContentChange} />
        </TabPanel>
      </CardContent>
    </Card>
  );
};

export default ExhibitContent;
